export default __webpack_public_path__ + "static/media/Nilus the Blood Wake.4f50e45e.jpg";